export const CourseMaterialTypeConstants = {
    PRINT: '6361ef4e-46b8-4298-87bb-265a569cb0e7',
    CD: '1b09eed5-dded-4fa9-8f65-83f667b41970',
    DOWNLOAD: 'c3ba3d39-0c87-402e-878c-f0167f459540',
}